// Song service for API calls

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Search songs
export const searchSongs = async (query, page = 1, limit = 10) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ArbSongs/searchForArbSong?query=${encodeURIComponent(query)}&page=${page}&limit=${limit}`);
    if (!response.ok) throw new Error('Search failed');
    return await response.json();
  } catch (error) {
    console.error('Error searching songs:', error);
    throw error;
  }
};

// Get song by ID
export const getSongById = async (songId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ArbSongs/getArbSongBySongID/${songId}`);
    if (!response.ok) throw new Error('Failed to fetch song');
    return await response.json();
  } catch (error) {
    console.error('Error fetching song:', error);
    throw error;
  }
};

// Get most popular songs
export const getMostPopularSongs = async (limit = 5) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ArbSongs/getMostPopularSongs?limit=${limit}`);
    if (!response.ok) throw new Error('Failed to fetch popular songs');
    return await response.json();
  } catch (error) {
    console.error('Error fetching popular songs:', error);
    throw error;
  }
};